module.exports = __webpack_public_path__ + "static/media/IMG_1883.3243a93d.JPG";